import { lazy } from 'react'

const Payment = lazy(() => import('../../views/pages/money/payment'))
const GCentToWCoin = lazy(() => import('../../views/pages/money/gcent-to-wcoin'))
const PaymentCard = lazy(() => import('../../views/pages/money/payment-card'))
const History = lazy(() => import('../../views/pages/money/history'))

const MoneyRoutes = [
	{
		path: '/money/card',
		element: <PaymentCard />,
		meta: {
			publicRoute: false
		}
	},
	{
		path: '/money/payment',
		element: <Payment />,
		meta: {
			publicRoute: false
		}
	},
	{
		path: '/money/history',
		element: <History />,
		meta: {
			publicRoute: false
		}
	},
	{
		path: '/money/gcent-to-wcoin',
		element: <GCentToWCoin />,
		meta: {
			publicRoute: false
		}
	}
]

export default MoneyRoutes
